export const billing = {
  title: '<b>შეავსეთ</b> ბალანსი<br /> რომ {{title}} მეტი.',
  titleNoMoney: '<b>მონეტები ამოიწურა</b><br /> შეავსეთ ბალანსი',
  confirmation: {
    title: 'დაადასტურეთ არჩევანი',
    packageDescription: 'შეძენას გაგრძელებთ გადახდის სისტემაში.',
    submitButton: 'შეძენის დადასტურება',
  },
  failedMessage: 'ოპერაცია ვერ მოხერხდა',
  successMessage: 'ყველაფერი კარგადაა. შეიტანეთ {amount}',
  cancelPurchase: {
    title: 'მონეტების შეძენის გაუქმება',
    description: 'დარწმუნებული ხართ, რომ გსურთ შეძენის გაუქმება?',
    applyText: 'დიახ',
    rejectText: 'არა',
  },
  balance: {
    title: 'ბალანსი',
    bonus: 'ბონუსი',
    add: 'შევსება',
    withdrawal: 'გამოტანა',
    promocode: 'პრომო კოდი',
    loadingBalance: 'ბალანსის ჩატვირთვა',
    loadingBonus: 'ბონუსის ჩატვირთვა',
    paymentHistory: 'გადახდების ისტორია',
    headers: {
      date: 'თარიღი',
      amount: 'თანხა',
      type: 'ტიპი',
      status: 'სტატუსი',
    },
    empty: 'გადახდები ვერ მოიძებნა',
    loading: 'გადახდების ჩატვირთვა...',
    loadingMore: 'მეტი გადახდის ჩატვირთვა...',
    loadFailed: 'გადახდების ისტორიის ჩატვირთვა ვერ მოხერხდა',
    loadMoreFailed: 'მეტი გადახდის ჩატვირთვა ვერ მოხერხდა',
    taskType: {
      coinsPurchase: 'მონეტების შეძენა',
      subscriptionPurchase: 'გამოწერა',
      cryptoDeposit: 'კრიპტო შევსება',
      cryptoWithdraw: 'კრიპტო გამოტანა',
      paypalDeposit: 'PayPal შევსება',
      cardDeposit: 'ბარათით შევსება',
      paypalWithdraw: 'PayPal გამოტანა',
    },
    taskStatus: {
      created: 'შექმნილი',
      pending: 'მოლოდინში',
      completed: 'დასრულებული',
      failed: 'ჩავარდა',
      finished: 'დასრულებული',
      canceled: 'გაუქმებული',
      error: 'შეცდომა',
    },
  },
  deposit: {
    ageRestrictionTitle: 'ასაკის შეზღუდვა',
    ageRestrictionText: 'შევსება ასაკის შეზღუდვის გამო ხელმიუწვდომელია.',
    firstDepositBonusTitle: 'პირველი შევსების ბონუსი',
    firstDepositBonusText:
      'პირველ $5+ შევსებაზე მიიღეთ <primary>$5 ბონუსი</primary>',
    title: 'შევსება',
    choosePaymentType: 'აირჩიეთ გადახდის ტიპი',
    paypal: 'PayPal',
    crypto: 'კრიპტო',
    card: 'ბარათი',
    googlePay: 'Google Pay',
    applePay: 'Apple Pay',
    amazonPay: 'Amazon Pay',
    weChatPay: 'WeChat Pay',
    amountUsd: 'თანხა (USD)',
    amountUsdt: 'თანხა (USDT)',
    enterAmount: 'შეიყვანეთ თანხა',
    minimumAmountNote: 'მინიმალური შევსება: {{amount}}',
    totalWithFee: 'თანხა სერვისის საფასურით (USD)',
    totalFeeNote: 'ეს არის სრული თანხა სერვისის საფასურის ჩათვლით.',
    network: 'ქსელი',
    createPaypalDeposit: 'PayPal შევსების შექმნა',
    createCryptoDeposit: 'კრიპტო შევსების შექმნა',
    createCardDeposit: 'ბარათით შევსების შექმნა',
    cardDetailsTitle: 'ბარათის მონაცემები',
    billingDetailsTitle: 'ბილინგის მონაცემები',
    billingDetailsSavedSummary: '{{firstName}} {{lastName}} · {{country}}',
    cardNumber: 'ბარათის ნომერი',
    cardNumberPlaceholder: '4111 1111 1111 1111',
    cardExpiry: 'მოქმედების ვადა',
    cardExpMonthPlaceholder: 'MM',
    cardExpYearPlaceholder: 'YY',
    cardCvv: 'კოდი',
    cardCvvPlaceholder: 'CVC',
    firstName: 'სახელი',
    lastName: 'გვარი',
    phone: 'ტელეფონი',
    address: 'მისამართი',
    city: 'ქალაქი',
    state: 'შტატი / რეგიონი',
    country: 'ქვეყანა',
    countrySearchPlaceholder: 'ქვეყნის ძებნა',
    countryListLabel: 'ქვეყნები',
    countryNoResults: 'ქვეყანა ვერ მოიძებნა',
    phoneNationalPlaceholder: '2063582043',
    phoneCodeSearchPlaceholder: 'კოდის ან ქვეყნის ძებნა',
    phoneCodeListLabel: 'ტელეფონის ქვეყნის კოდები',
    zipCode: 'ZIP / საფოსტო კოდი',
    cardManualContinue:
      'თუ გადამისამართება არ მოხდა, ბარათის ავთენტიფიკაცია ხელით გააგრძელეთ:',
    openCardAuthentication: 'ბარათის ავთენტიფიკაციის გვერდის გახსნა',
    createGooglePayDeposit: 'Google Pay-ით გაგრძელება',
    createApplePayDeposit: 'Apple Pay-ით გაგრძელება',
    createAmazonPayDeposit: 'Amazon Pay-ით გაგრძელება',
    createWeChatPayDeposit: 'WeChat Pay-ით გაგრძელება',
    dodoManualContinue:
      'თუ გადამისამართება არ მოხდა, ბარათის გადახდა ხელით გააგრძელეთ:',
    openDodoCheckout: 'გადახდის გვერდის გახსნა',
    paypalManualContinue:
      'თუ გადამისამართება არ მოხდა, PayPal-ის დადასტურება ხელით გააგრძელეთ:',
    openPaypalApproval: 'PayPal დადასტურების გვერდის გახსნა',
    cryptoManualContinue:
      'თუ გადამისამართება არ მოხდა, გადახდა ხელით გააგრძელეთ:',
    openPaymentPage: 'გადახდის გვერდის გახსნა',
    processingTitle: 'PayPal გადახდის დამუშავება',
    processingText: 'PayPal გადახდა მუშავდება...',
    toast: {
      amountPositive: 'თანხა უნდა იყოს დადებითი რიცხვი',
      minimumAmount: 'მინიმალური შევსების თანხაა {{amount}}',
      depositLinkMissing:
        'შევსების დავალება შეიქმნა, მაგრამ გადახდის ბმული არ დაბრუნდა',
      depositCreated: 'შევსების დავალება შეიქმნა. გადამისამართება გადახდაზე...',
      paypalLinkMissing:
        'PayPal დავალება შეიქმნა, მაგრამ დადასტურების ბმული არ დაბრუნდა',
      paypalCreated:
        'PayPal დავალება შეიქმნა. გადამისამართება დადასტურებაზე...',
      paypalTokenMissing: 'PayPal token არ დაბრუნდა',
      paypalCaptureFailed: 'PayPal გადახდის დაფიქსირება ვერ მოხერხდა',
      unsupportedCardType: 'მხარდაჭერილია მხოლოდ Visa და Mastercard',
      invalidCardExpiryMonth: 'შეიყვანეთ სწორი თვე (01–12)',
      invalidCardExpiryYear: 'შეიყვანეთ 2-ნიშნა წელი',
      invalidCardNumber: 'ბარათის ნომერი არასწორია',
      cardDepositCompleted: 'ბარათით შევსება წარმატებით დასრულდა',
      cardDepositProcessing: 'გადახდა მუშავდება. ბალანსი მალე განახლდება.',
    },
  },
  promocode: {
    title: 'პრომო კოდი',
    description: 'გამოიყენეთ პრომო კოდი ბონუს მონეტების მისაღებად',
    codeLabel: 'პრომო კოდი',
    codePlaceholder: 'შეიყვანეთ პრომო კოდი',
    submit: 'გამოყენება',
    codeRequired: 'შეიყვანეთ პრომო კოდი',
    success: 'პრომო კოდი გააქტიურდა. მიიღეთ {{amount}} ბონუსი.',
  },
  withdrawal: {
    securityRequirements: 'უსაფრთხოების მოთხოვნები',
    ageRestrictedTitle: 'გამოტანა ასაკის შეზღუდვის გამო ხელმიუწვდომელია.',
    ageRestrictedHint: 'უნდა იყოთ მინიმუმ {{age}} წლის.',
    mfaRequiredTitle: 'გამოტანა ხელმისაწვდომია მხოლოდ ჩართული 2FA-ით.',
    mfaRequiredHint:
      'ჩართეთ ორფაქტორიანი ავტორიზაცია თქვენი სახსრების დასაცავად და გამოტანის უსაფრთხოდ დასასრულებლად.',
    enable2fa: '2FA-ს ჩართვა',
    kycRequiredTitle: 'საჭიროა ვინაობის დადასტურება',
    kycPending:
      'დადასტურება მიმდინარეობს. დაასრულეთ Veriff და განაახლეთ სტატუსი.',
    kycResubmission:
      'Veriff-მა მოითხოვა დამატებითი დოკუმენტი. გააგრძელეთ დადასტურება და განაახლეთ სტატუსი.',
    kycRequired: 'გამოტანას სჭირდება ვინაობის დადასტურება.',
    startKyc: 'KYC-ს დაწყება',
    continueKyc: 'KYC-ს გაგრძელება',
    refreshStatus: 'სტატუსის განახლება',
    paypalTitle: 'PayPal გამოტანა',
    paypalIntro:
      'მიუთითეთ თანხა, PayPal ელ. ფოსტა და 2FA კოდი გადახდის მოსათხოვნად.',
    amountUsd: 'თანხა (USD)',
    paypalEmail: 'PayPal ელ. ფოსტა',
    paypalEmailPlaceholder: 'name@example.com',
    tfaCode: '2FA კოდი',
    tfaCodePlaceholder: 'შეიყვანეთ 2FA კოდი',
    requestPaypalPayout: 'PayPal გადახდის მოთხოვნა',
    cryptoTitle: 'კრიპტო გამოტანა',
    amountUsdt: 'თანხა (USDT)',
    network: 'ქსელი',
    address: 'მისამართი',
    addressPlaceholder: 'შეიყვანეთ USDT მისამართი',
    createCryptoWithdraw: 'კრიპტო გამოტანის შექმნა',
    payoutNotice:
      'აქტიურად ვმუშაობთ გადახდების დებეტური ბარათებზე ან საბანკო ანგარიშებზე რაც შეიძლება სწრაფად განსახორციელებლად. ბოდიშს გიხდით შესაძლო უხერხულობისთვის.',
    toast: {
      amountPositive: 'თანხა უნდა იყოს დადებითი რიცხვი',
      withdrawCreated: 'გამოტანის დავალება შეიქმნა',
      paypalPayoutCreated: 'PayPal გადახდის მოთხოვნა შეიქმნა',
    },
  },
  error: {
    requestFailed: 'მოთხოვნა ვერ მოხერხდა',
    kycRequired: 'გამოტანას სჭირდება ვინაობის დადასტურება.',
    kycPending: 'დადასტურება კვლავ მიმდინარეობს.',
    kycResubmission: 'Veriff-ს სჭირდება დამატებითი დოკუმენტი.',
    withdrawAcquirerFailed:
      'გამოტანის სერვისი დროებით ხელმიუწვდომელია. დაჯავშნული ბალანსი დაბრუნდა.',
  },
};
